module.exports = __webpack_public_path__ + "static/media/3@3x.76720128.png";